import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.validate();
  }

  validate() {
    const field = (suffix) => this.element.querySelector(`[name$="[${suffix}]"]`);
    const commercial = parseFloat(field("commercial_value")?.value);
    const customs = field("taxable_amount");
    const gross = parseFloat(field("gross_weight_kg")?.value);
    const net = field("net_weight_kg");

    if (customs) {
      const value = parseFloat(customs.value);
      customs.setCustomValidity(
        !isNaN(commercial) && !isNaN(value) && value < commercial
          ? "Customs value must be greater than or equal to the commercial value"
          : ""
      );
    }
    if (net) {
      const value = parseFloat(net.value);
      net.setCustomValidity(
        !isNaN(gross) && !isNaN(value) && value > gross
          ? "Net weight cannot exceed gross weight"
          : ""
      );
    }
  }
}
